import React, { useState } from "react";
import * as S from './ForgotPasswordStyle';
import { passwordService } from "../../Services/passwordService";
import { FiMail, FiArrowLeft, FiCheckCircle } from 'react-icons/fi';
import { useNavigate } from "react-router-dom";
import { getClientIp } from "../../assets/utils";

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const navigate = useNavigate();

    const handleRequestReset = async (e) => {
        e.preventDefault();
        if (email.trim() === '') {
            setMessage("Por favor, insira um e-mail válido.");
            setIsSuccess(false);
            return;
        }

        var ip = await getClientIp();

        setIsLoading(true);
        setMessage('');
        try {
            const response = await passwordService.requestPasswordReset(email, ip);
            setMessage(response.message);
            setIsSuccess(true);
        } catch (error) {
            setMessage("Se um e-mail correspondente for encontrado em nosso sistema, um link para redefinição de senha será enviado.");
            setIsSuccess(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <S.Container>
            <S.BoxCenter>
                <S.Logo src="/logo-golden.png" alt="Golden Brasil" />

                {isSuccess ? (
                    <S.SuccessContainer>
                        <S.SuccessIcon>
                            <FiCheckCircle />
                        </S.SuccessIcon>
                        <S.Title>Verifique seu E-mail</S.Title>
                        <S.Message isSuccess={true}>{message}</S.Message>
                        <S.BackButton onClick={() => navigate('/')}>
                            <FiArrowLeft /> Voltar para o Login
                        </S.BackButton>
                    </S.SuccessContainer>
                ) : (
                    <>
                        <S.Title>Esqueceu sua senha?</S.Title>
                        <S.Subtitle>Não se preocupe! Insira seu e-mail abaixo e enviaremos um link para você criar uma nova senha.</S.Subtitle>
                        <S.Form onSubmit={handleRequestReset}>
                            <S.InputWrapper>
                                <S.Icon><FiMail /></S.Icon>
                                <S.Input
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="email"
                                    placeholder="seu.email@exemplo.com"
                                    value={email}
                                    disabled={isLoading}
                                    required
                                />
                            </S.InputWrapper>
                            <S.SubmitButton type="submit" disabled={isLoading}>
                                {isLoading ? "ENVIANDO..." : "ENVIAR LINK"}
                            </S.SubmitButton>
                            {message && <S.Message isSuccess={isSuccess}>{message}</S.Message>}
                        </S.Form>
                    </>
                )}
            </S.BoxCenter>
        </S.Container>
    );
}